module.exports = {
      id: "email-usage",
      viewBox: "0 0 16 12",
      url: __webpack_public_path__ + "img/icons.91580017.svg#email-usage",
      toString: function () {
        return this.url;
      }
    }